import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { WebEngage, GA, PGAD } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import { fetchTK } from "../../../api";
import { get } from "lodash";
import { Icon } from "../../atoms/icon";

const ThirukuralExplanationPage = ({ data }) => {
  const [kuralData, setKuralData] = useState(null);
  // const [expandedSection, setExpandedSection] = useState("explanation");
  const [allKurals, setAllKurals] = useState([]);
  const [currentKuralIndex, setCurrentKuralIndex] = useState(0);

  const [kuralMapping, setKuralMapping] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const createKuralMapping = structureData => {
    const mapping = {};
    const reverseMapping = {}; // For adhikaram to kural range mapping
    let currentKuralNumber = 1;
    let adhikaramCounter = 1; // sequential adhikaram number

    if (!structureData || !structureData[0] || !structureData[0].section) {
      return { mapping: {}, reverseMapping: {} };
    }

    structureData[0].section.detail.forEach(paal => {
      paal.chapterGroup.detail.forEach(iyal => {
        iyal.chapters.detail.forEach(adhikaram => {
          const startKural = currentKuralNumber;
          const endKural = currentKuralNumber + 9; // Each adhikaram has 10 kurals

          // Store reverse mapping for quick lookup
          reverseMapping[adhikaramCounter] = {
            start: startKural,
            end: endKural,
            paal: paal.name,
            iyal: iyal.name,
            adhikaram: adhikaram.name,
            adhikaramNumber: adhikaramCounter
          };

          // Map each individual kural number
          for (let kuralNum = startKural; kuralNum <= endKural; kuralNum++) {
            mapping[kuralNum] = {
              adhikaram: adhikaram.name,
              paal: paal.name,
              iyal: iyal.name,
              adhikaramStart: startKural,
              adhikaramEnd: endKural,
              adhikaramNumber: adhikaramCounter
            };
          }

          currentKuralNumber += 10;
          adhikaramCounter += 1;
        });
      });
    });

    return { mapping, reverseMapping };
  };

  // // Dynamic function to get adhikaram for a kural number
  // const getAdhikaramForKural = kuralNumber => {
  //   if (kuralMapping[kuralNumber]) {
  //     return kuralMapping[kuralNumber].adhikaram;
  //   }
  //   return "அறியாத-அதிகாரம்";
  // };

  useEffect(() => {
    // Initialize with real data from API
    const initializeData = async () => {
      try {
        setLoading(true);
        const fetchedData = await fetchTK();
        const kData = get(fetchedData, ["kural"], []);
        const kList = get(fetchedData, ["items"], []);

        console.log("Fetched kural data count:", kData.length);
        console.log("Structure data:", kList);

        // Create dynamic mappings
        const { mapping } = createKuralMapping(kList);
        setKuralMapping(mapping);

        // Initialize all kurals
        setAllKurals(kData);

        // Get kural number from URL path
        const pathSegments = window.location.pathname.split("/");
        const kuralNumberFromUrl = pathSegments[pathSegments.length - 1];

        if (kuralNumberFromUrl) {
          try {
            const number = parseInt(kuralNumberFromUrl);
            const kural = kData.find(k => k.Number === number);

            if (kural) {
              setKuralData(kural);

              // Find the current kural index
              const index = kData.findIndex(k => k.Number === number);
              setCurrentKuralIndex(index >= 0 ? index : 0);
            } else {
              setError(`குறள் எண் ${number} கிடைக்கவில்லை`);
            }
          } catch (error) {
            setError("குறள் எண்ணை பாகுபடுத்துவதில் பிழை");
            console.error("Error parsing kural number:", error);
          }
        } else {
          setError("குறள் எண் URL-ல் கிடைக்கவில்லை");
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching Thirukural data:", err);
        setError("திருக்குறள் தரவு பெறுவதில் பிழை");
        setLoading(false);
      }
    };

    initializeData();

    // Analytics
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.THIRUKURAL_EXPLANATION_PAGE, { collection: data.collection });
    PGAD.loadScript();
  }, []);

  const handleBackToKurals = () => {
    window.location.href = "/thirukural";
  };

  // const handleSectionToggle = section => {
  //   setExpandedSection(expandedSection === section ? null : section);
  // };

  // const handlePreviousKural = () => {
  //   if (currentKuralIndex > 0) {
  //     const prevKural = allKurals[currentKuralIndex - 1];
  //     const prevAdhikaram = getAdhikaramForKural(prevKural.Number);
  //     const urlFriendlyAdhikaram = prevAdhikaram.replace(/\s+/g, "-");
  //     window.location.href = `/thirukural/${urlFriendlyAdhikaram}/${prevKural.Number}`;
  //   }
  // };

  // const handleNextKural = () => {
  //   if (currentKuralIndex < allKurals.length - 1) {
  //     const nextKural = allKurals[currentKuralIndex + 1];
  //     const nextAdhikaram = getAdhikaramForKural(nextKural.Number);
  //     const urlFriendlyAdhikaram = nextAdhikaram.replace(/\s+/g, "-");
  //     window.location.href = `/thirukural/${urlFriendlyAdhikaram}/${nextKural.Number}`;
  //   }
  // };

  const handlePreviousKural = () => {
    if (currentKuralIndex > 0) {
      const prevKural = allKurals[currentKuralIndex - 1];
      const mappingInfo = kuralMapping[prevKural.Number];
      if (!mappingInfo) return;
      window.location.href = `/thirukural/${mappingInfo.adhikaramNumber}/${prevKural.Number}`;
    }
  };

  const handleNextKural = () => {
    if (currentKuralIndex < allKurals.length - 1) {
      const nextKural = allKurals[currentKuralIndex + 1];
      const mappingInfo = kuralMapping[nextKural.Number];
      if (!mappingInfo) return;
      window.location.href = `/thirukural/${mappingInfo.adhikaramNumber}/${nextKural.Number}`;
    }
  };

  // Loading state
  if (loading) {
    return (
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div className="page-content infinity-page">
          <div className={`${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <div className={`${styles["thirukural-div"]}`}>
                <div className="container">
                  {/* <div className={`${styles["thirukural-header"]}`}>
                    <h1>தரவு ஏற்றுகிறது...</h1>
                    <p>தயவுசெய்து காத்திருக்கவும்</p>
                  </div> */}
                  <div className={`${styles["thirukural-header"]}`}>
                    <div>
                      <img src="https://images.assettype.com/vikatan/2025-08-29/r7mga4i5/thiruvalluvar.png" alt="" />
                    </div>
                    <h1>தரவு ஏற்றுகிறது...</h1>
                    <p>
                      தயவுசெய்து <br />
                      காத்திருக்கவும்
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error || !kuralData) {
    return (
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div className="page-content infinity-page">
          <div className={`${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <div className={`${styles["thirukural-div"]}`}>
                <div className="container">
                  <div className={`${styles["thirukural-header"]}`}>
                    <h1>பிழை</h1>
                    <p>{error || "குறள் தரவு கிடைக்கவில்லை"}</p>
                  </div>
                  <button onClick={handleBackToKurals} className={`${styles["back-btn"]}`}>
                    ← திருக்குறள்களுக்கு திரும்பு
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
      <div className="page-content infinity-page">
        <div className={`${styles["story-grid"]}`}>
          <div className={`${styles["main-container"]}`}>
            <div className={`${styles["thirukural-div"]}`}>
              <div className="container">
                <div className={`${styles["thirukural-header"]}`}>
                  <div>
                    <img src="https://images.assettype.com/vikatan/2025-08-29/r7mga4i5/thiruvalluvar.png" alt="" />
                  </div>
                  <h1>திருக்குறள் விளக்கம்</h1>
                  <p className={`${styles["thirukural-header-kural-number"]}`}>
                    குறள் எண்: <br />
                    {kuralData.Number}
                  </p>
                </div>

                <div className={`${styles["explanation-page-content"]}`}>
                  {/* Main Kural Display */}
                  <div className={`${styles["kural-main-section"]}`}>
                    <div>
                      <img src="https://images.assettype.com/vikatan/2025-08-29/r7mga4i5/thiruvalluvar.png" alt="" />
                    </div>
                    <div className={`${styles["kural-number-section"]}`}>
                      <div className={`${styles["kural-number-large"]}`}>{kuralData.Number}</div>
                      <div className={`${styles["kural-couplet-large"]}`}>
                        <div className={`${styles["kural-line"]}`}>{kuralData.Line1}</div>
                        <div className={`${styles["kural-line"]}`}>{kuralData.Line2}</div>
                      </div>
                    </div>
                  </div>

                  {/* Navigation Buttons */}
                  <div className={`${styles["navigation-buttons"]}`}>
                    <div className={`${styles["kural-navigation"]}`}>
                      <button onClick={handleBackToKurals} className={`${styles["back-btn"]}`}>
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} /> திருக்குறள்களுக்கு திரும்பு
                      </button>
                    </div>
                  </div>

                  {/* Navigation Tabs */}
                  {/* <div className={`${styles["explanation-tabs"]}`}>
                    <button
                      onClick={() => handleSectionToggle("explanation")}
                      className={`${styles["tab-btn"]} ${
                        expandedSection === "explanation" ? styles["active-tab"] : ""
                      }`}
                    >
                      விளக்கம்
                      <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                    </button>
                    <button
                      onClick={() => handleSectionToggle("translation")}
                      className={`${styles["tab-btn"]} ${
                        expandedSection === "translation" ? styles["active-tab"] : ""
                      }`}
                    >
                      பொருள்
                      <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                    </button>
                    {kuralData.sp && (
                      <button
                        onClick={() => handleSectionToggle("sp")}
                        className={`${styles["tab-btn"]} ${expandedSection === "sp" ? styles["active-tab"] : ""}`}
                      >
                        சிறப்பு விளக்கம்
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                      </button>
                    )}
                    {kuralData.mk && (
                      <button
                        onClick={() => handleSectionToggle("mk")}
                        className={`${styles["tab-btn"]} ${expandedSection === "mk" ? styles["active-tab"] : ""}`}
                      >
                        முக்கிய கருத்து
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                      </button>
                    )}
                    {kuralData.transliteration1 && (
                      <button
                        onClick={() => handleSectionToggle("transliteration")}
                        className={`${styles["tab-btn"]} ${
                          expandedSection === "transliteration" ? styles["active-tab"] : ""
                        }`}
                      >
                        எழுத்துக்கள்
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                      </button>
                    )}
                    {kuralData.couplet && (
                      <button
                        onClick={() => handleSectionToggle("couplet")}
                        className={`${styles["tab-btn"]} ${expandedSection === "couplet" ? styles["active-tab"] : ""}`}
                      >
                        ஆங்கில விளக்கம்
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} />
                      </button>
                    )}
                  </div> */}

                  {/* Content Sections */}
                  <div className={`${styles["explanation-sections"]}`}>
                    {/* Explanation Section */}
                    {/* {expandedSection === "explanation" && ( */}
                    <div className={`${styles["explanation-section"]}`}>
                      <h3>விளக்கம்</h3>
                      <p>{kuralData.mv || kuralData.explanation || "விளக்கம் கிடைக்கவில்லை"}</p>
                    </div>
                    {/* )} */}

                    {/* Translation Section */}
                    {/* {expandedSection === "translation" && ( */}
                    <div className={`${styles["translation-section"]}`}>
                      <h3>பொருள்</h3>
                      <p>{kuralData.Translation || "பொருள் கிடைக்கவில்லை"}</p>
                    </div>
                    {/* )} */}

                    {/* Special Explanation Section */}
                    {/* {expandedSection === "sp" &&
                      kuralData.sp && ( */}
                    <div className={`${styles["sp-section"]}`}>
                      <h3>சிறப்பு விளக்கம்</h3>
                      <p>{kuralData.sp}</p>
                    </div>
                    {/* )} */}

                    {/* Key Point Section */}
                    {/* {expandedSection === "mk" &&
                      kuralData.mk && ( */}
                    <div className={`${styles["mk-section"]}`}>
                      <h3>முக்கிய கருத்து</h3>
                      <p>{kuralData.mk}</p>
                    </div>
                    {/* )} */}

                    {/* Transliteration Section */}
                    {/* {expandedSection === "transliteration" &&
                      kuralData.transliteration1 && ( */}
                    <div className={`${styles["transliteration-section"]}`}>
                      <h3>எழுத்துக்கள்</h3>
                      <p>
                        {kuralData.transliteration1} {kuralData.transliteration2}
                      </p>
                    </div>
                    {/* )} */}

                    {/* English Couplet Section */}
                    {/* {expandedSection === "couplet" &&
                      kuralData.couplet && ( */}
                    <div className={`${styles["couplet-section"]}`}>
                      <h3>ஆங்கில விளக்கம்</h3>
                      <p>{kuralData.couplet}</p>
                    </div>
                    {/* )} */}
                  </div>

                  {/* Navigation Buttons */}
                  <div className={`${styles["navigation-buttons"]}`}>
                    <div className={`${styles["kural-navigation"]}`}>
                      <button
                        onClick={handlePreviousKural}
                        disabled={currentKuralIndex === 0}
                        className={`${styles["nav-btn"]} ${styles["prev-btn"]}`}
                      >
                        <Icon type={"slider-next"} className={`${styles["prev-icon"]}`} /> முந்தைய குறள்
                      </button>

                      <button
                        onClick={handleNextKural}
                        disabled={currentKuralIndex === allKurals.length - 1}
                        className={`${styles["nav-btn"]} ${styles["next-btn"]}`}
                      >
                        அடுத்த குறள் <Icon type={"slider-next"} className={`${styles["next-icon"]}`} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ThirukuralExplanationPage };

ThirukuralExplanationPage.propTypes = {
  data: PropTypes.shape()
};
